export const Permission = {
  ADMIN: 'isAdmin',
} as const;

export type ObjectValues<T> = T[keyof T];

export type Permission = ObjectValues<typeof Permission>;
